import React, { useState, useEffect, useRef } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch } from "react-redux";
//API
import ItemService from "../../../../services/supplier_appCommonService";
import ItemServiceCustomer from "../../../../services/customer_appCommonService";
import logistics from "../../../../services/logistics_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import Constants from "../../../../common/SupplierConstants";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import toast from "react-hot-toast";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
// for map block
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import GoogleMapComponentFromTo from "../../Common/GoogleMapComponentFromTo";
import LogisticsConstants from "../../../../common/LogisticsConstants";
import { useNavigate } from "react-router-dom";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { validateRequired } from "../../../../common/Validations";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};


const CreateTransportRequest = () => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
    const navigate = useNavigate();
  
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Transport Request");

  // localStorage.setItem("menu", "Purchasing");
  // localStorage.setItem("submenu", "Purchase Order");

  // let selectedPoDetails = useSelector(
  //   (state) => state?.purchasing?.purchase_order?.selectedPoDetails
  // ); // selectedPoDetails Details from Store

  // let poNumber = useSelector(
  //   (state) => state?.purchasing?.purchase_order?.poNumber
  // ); // purchase_order from Store

  // let userData = useSelector((state) => state?.user.data); // User Details from Store

  const modalData = {
    title: "ASN Creation",
    successMsg: "",
  };
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo /*setModalInfo*/] = useState(modalData);
  const [getHeaderData /*setHeaderData*/] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [itemTableData /*setItemTableData*/] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);

  const [getItemLevelData /* setItemLevelData*/] = useState([]);
  const [getItemLevelColumns /*setItemLevelColumns*/] = useState([]);
  const [getModalTitle /*setModalTitle*/] = useState("");
  const [getViewHeaderText, setViewHeaderText] = useState(false);
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);
  const [validation, setValidation] = useState({
        driverName: "",
      });
  
  // added new one for

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);



  const [invoiceData, setInvoiceData] = useState([]);
  const [getDropdownData, setDropdownData] = useState([]);

  const [getCustomer, setCustomer] = useState([]);

  const [getGrossValue, setGrossValue] = useState(0);
  useEffect(() => {
    const subtotal = Number(subTotalValue) || 0;
    const otherCharges = Number(getOtherChargesValue) || 0;
    setGrossValue(subtotal + otherCharges);
  }, [subTotalValue, getOtherChargesValue]);

 



  let SchedulePOLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span style={{ marginLeft: "12px" }}>
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange1(row.local_id, event, "purchaseQuantity")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange1(row.local_id, event, "orderPriceUnit")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value",
      selector: (row) => row.itemValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemValue"
          placeholder=""
          value={row.itemValue || ""}
          disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    // {
    //   name: "Delivery Date",
    //   selector: (row) => row.deliveryDate || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       type="date"
    //       name="deliveryDate"
    //       placeholder=""
    //       value={row.deliveryDate || ""}
    //       onChange={(event) => handleInputChange(row.local_id, event)}
    //     />
    //   ),
    //   width: "200px",
    // },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          // value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let SchedulePOLineItemInitialCol1 = [
    {
      name: "Trip Id",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Trip Started Date ",
      selector: (row) => row.tripStartedDate1 || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          // label="Please Enter the Remarks*"
          name="tripStartedDate1"
          placeholder=""
          value={row.tripStartedDate1 || ""}
          onChange={(event) => handleInputChange2(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "From Location",
      selector: (row) => row.fromLocation1 || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="fromLocation1"
          placeholder=""
          value={row.fromLocation1 || ""}
          onChange={(event) => handleInputChange2(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "To Location ",
      selector: (row) => row.toLocation1 || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="toLocation1"
          placeholder=""
          value={row.toLocation1 || ""}
          onChange={(event) => handleInputChange2(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Trip KMS ",
      selector: (row) => row.tripKMS || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="tripKMS"
          placeholder=""
          value={row.tripKMS || ""}
          onChange={(event) => handleInputChange2(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow1(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  const [HeaderTextModel, setHeaderTextModel] = useState(false);
  /* Create Header Text Modal Function */
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Value",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
    // {
    //   name: "Delete",
    //   cell: (row, index) => (
    //     <>
    //       <span>
    //         <i
    //           onClick={() => handleDelete(index)}
    //           className="bi bi-trash text-danger fs-3"
    //         ></i>
    //       </span>
    //     </>
    //   ),
    //   width: "10rem",
    // },
  ];

  const addInvoiceDocument = () => {
    // Create a new document with some data (you can customize the content)
    const newDocument = {
      id: Date.now(),
      name: `Document ${invoiceData.length + 1}`,
    };
    // Update the state with the new document
    setInvoiceData((prevData) => [...prevData, newDocument]);
  };

  const deleteInvoiceDocument = (id) => {
    // Filter out the document with the given id
    const updatedData = invoiceData.filter((doc) => doc.id !== id);
    // Update the state with the remaining documents
    setInvoiceData(updatedData);
  };

  /* radio buttons */
  const [selectedShipment, setSelectedShipment] = useState("road");

  const handleShipmentChange = (event) => {
    setSelectedShipment(event.target.value);
  };

  const [formInputs, setFormInputs] = useState({
    pricingSummary: {
      subTotalValue: "",
      getOtherChargesValue: "",
      grossTotalValue: "",

    },
    transportrequestDetails: {
      transportRequestDate: "",
      department: "",
      transportGroup: "",
      purchaseOrderNr: "",
      vehicleNr: "",
      driverName1:"",
      licenseNr: "",
      issuingDate: "",
      expiryDate: "",
    },
    senderAddress: {
      customerDetails: "",

    },
    oneWayTrip: {
      tripTypes: "",
      tripstartDate: "",
      fromLocation: "",
      toLocation: "",
    },
    twoWayTrip: {
      tripstartDate2: "",
      fromLocation2: "",
      toLocation2: ""

    }
  });


  const [getShipment, setShipment] = useState({
    road: {
      truckNo: "",
      challanDate: "",
      challanNo: "",
      dateOfDispatch: "",
      driverName: "",
      driverNumber: "",
      eWaybillValue: "",
      ewaybillNo: "",
      expectedDeliveryDate: "",
      lrDate: "",
      lrNo: "",
      modeOfPacking: "",
      noOfPackages: "",
      placeOfDelivery: "",
      placeOfLoading: "",
      transporterCourier: "",
      weightOfConsignment: "",
      tripTypes: "",

    },
    air: {
      hawbDate: "",
      hawbNo: "",
      NoofPackages: "",
      airportOfArrival: "",
      airportOfShipment: "",
      billOfEntryDate: "",
      billOfEntryNo: "",
      courier: "",
      dateOfDispatch: "",
      eWaybillValue: "",
      ewaybillNo: "",
      expectedDeliveryDate: "",
      mawbDate: "",
      mawbNo: "",
      transporterName: "",
      weightOfConsignment: "",
    },
    courier: {
      courierName: "",
      dateOfDispatch: "",
      docketDate: "",
      docketNo: "",
      ewaybillNo: "",
      expectedArrivalDate: "",
      modeOfPacking: "",
      noOfPackages: "",
      weightOfConsignment: "",
    },
    ship: {
      billOfLadinDate: "",
      billOfLading: "",
      bookingNumber: "",
      dateOfDispatch: "",
      internalReferenceNumber: "",
      shippineLine: "",
    },
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };

  // const [getShippingFrom, setShippingFrom] = useState();
  // console.log(" => getShippingFrom", getShippingFrom);

  // const [getshippingTo, setshippingTo] = useState();
  const [gettransportRequest, settransportRequest] = useState({});
  // const [getTripDetails, setTripDetails] = useState({});

  // console.log(" => getShippingFrom", getshippingTo);
  const [getCustomerDetails, setCustomerDetails] = useState(null);
  const [senderOthersCustomer, setSenderOthersCustomer] = useState(false); // default false

  const tripType = [
    { id: 1, name: "Round Trip", textField: "Select trip Type" },
    { id: 2, name: "One Way Trip", textField: "Select trip Type" },
    { id: 3, name: "Two Way Trip", textField: "Select trip Type" },

  ]

  const handleOnAddSender = () => {
    setSenderOthersCustomer(!senderOthersCustomer);
    setCustomerDetails(defaultCustomerDetails);
  };

  const defaultCustomerDetails = {
    customerName: "",
    address: "",
    address2: "",
    address3: "",
    state: "",
    cityPostalCode: "",
    certifications: "",

  };


  const getCustomerDetail = async (userId) => {
    let obj1 = {
      documentNumber: userId,
    };
    await ItemServiceCustomer.getCustomerDetail(obj1).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setCustomerDetails(item?.data[0] || null);
      } else {
        setCustomerDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };
  //reciver
  const [getTripType, setTripType] = useState({
    // tripType:{
    //     tripType:"",
    //     tripstartDate:"",
    //     fromLocation:"",
    //     toLocation:"", 
    // }
  }


  );
  const [getTripType1, setTripType1] = useState({

  });
  const [getReciverCustomerDetails, setReciverCustomerDetails] = useState(null);
  const [reciverOthersCustomer, setReciverOthersCustomer] = useState(false); // default false

  const hanleOnAddReceiver = () => {
    setReciverOthersCustomer((prev) => !prev);

    // Reset the manual entry fields
    setReciverCustomerDetails(defaultReciverCustomerDetails);

    // Also clear the dropdown selection (assuming `formInputs` manages dropdown state)
    setFormInputs((prev) => ({
      ...prev,
      reciverCustomerName: "",
      reciverCustomerCode: "",
      reciverCustomerNameDesc: "",
    }));
  };


  const defaultReciverCustomerDetails = {
    customerName: "",
    address: "",
    address2: "",
    address3: "",
    state: "",
    cityPostalCode: "",
    certifications: "",
  };

  const getCustomerDetailReciver = async (userId) => {
    let obj1 = {
      documentNumber: userId,
    };
    await ItemServiceCustomer.getCustomerDetail(obj1).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setReciverCustomerDetails(item?.data[0] || null);
      } else {
        setReciverCustomerDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    // console.log(">>getDropdownData",getDropdownData)
    if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
      }));
      getCustomerDetail(getDropdownData?.id);
    } else if (getDropdownData?.textCode === "reciverCustomerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
      }));
      getCustomerDetailReciver(getDropdownData?.id);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };
  const TripTypeonInputChange = ({ target: { name, value } }) => {
    setTripType((getTripType) => ({ ...getTripType, [name]: value }));
  };
  const TripTypeonInputChange1 = ({ target: { name, value } }) => {
    setTripType1((getTripType1) => ({ ...getTripType1, [name]: value }));
  };

  // const transportRequestInputchange = ({ target: { name, value } }) => {
  //   settransportRequest((gettransportRequest) => ({
  //     ...gettransportRequest,
  //     [name]: value,
      
  //   }));
  // };
  const transportRequestInputchange = ({ target: { name, value } }) => {
    const errors=[]
    settransportRequest((gettransportRequest) => {
      const updatedData = {
        ...gettransportRequest,
        [name]: value,
      };
      setFormInputs((prev) => ({
        ...prev,
        [name]: value,
      }));
      setValidation((prev) => ({
        ...prev,
        [name]: errors[name] || "",
      }));
  
      // if (name === "expiryDate") {
      //   const expiry = new Date(value);
      //   const today = new Date();
      //   today.setHours(0, 0, 0, 0); // remove time portion
  
      //   if (expiry <= today) {
      //     alert("The expiry date is not valid. The driver should not be allowed to the trip.");
      //     // Optionally clear the expiry date or handle UI update here
      //     updatedData.expiryDate = "";
      //   }
      // }
  
      return updatedData;
    });
  };
  
  const pricingSummaryInputchange = ({ target: { name, value } }) => {
    setSubTotalValue((subTotalValue) => ({
      ...subTotalValue,
      [name]: value,
    }));
  };
  const otherChargeInputchange = ({ target: { name, value } }) => {
    setOtherChargesValue((getOtherChargesValue) => ({
      ...getOtherChargesValue,
      [name]: value,
    }));
  };
  const GrossValueInputchange = ({ target: { name, value } }) => {
    setGrossValue((getGrossValue) => ({
      ...getGrossValue,
      [name]: value,
    }));
  };

  const handleRadioChange = (event) => {
    const { name, value } = event.target;
    setShipment((prevData) => ({
      ...prevData,
      [selectedShipment]: {
        ...prevData[selectedShipment],
        [name]: value,
      },
    }));
    setShipment((prevData) => ({
      ...prevData,
      [selectedShipment]: {
        ...prevData[selectedShipment],
        [name]: value,
      },
    }));
  };
  const onSuccessUploadDocumentType = (data) => {
    setInvoiceData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  /* Shipment details fields */

  const renderShipmentDetails = () => {
    switch (selectedShipment) {
      case "road":
        return (
          <>
            <div className="accordion-body pb-4">
              <Row>
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  className="commTopButtonRightLeftPadding"
                >
                  <p className="fs-5 fw-medium ms-2 pt-4">
                    Road Shipment Details
                  </p>
                  <hr className="mx-2" />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Date of Dispatch"
                    name="dateOfDispatch"
                    id="dateOfDispatch"
                    min={2023}
                    value={getShipment?.road?.dateOfDispatch}
                    onChange={handleRadioChange}
                    type="date"
                    disabled={false}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="LR No"
                    name="lrNo"
                    id="lrNo"
                    value={getShipment?.road?.lrNo}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="LR Date"
                    name="lrDate"
                    id="lrDate"
                    min={2023}
                    value={getShipment?.road?.lrDate}
                    type="date"
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Expected Delivery Date"
                    name="expectedDeliveryDate"
                    id="expectedDeliveryDate"
                    min={2023}
                    value={getShipment?.road?.expectedDeliveryDate}
                    onChange={handleRadioChange}
                    type="date"
                    disabled={false}
                  />
                </Col>

                {/* <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="EWaybill No"
                    name="ewaybillNo"
                    id="ewaybillNo"
                    value={getShipment?.road?.ewaybillNo}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col> */}

                {/* <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="E Waybill Value"
                    name="eWaybillValue"
                    id="eWaybillValue"
                    value={getShipment?.road?.eWaybillValue}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col> */}

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Challan No"
                    name="challanNo"
                    id="challanNo"
                    value={getShipment?.road?.challanNo}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Challan Date"
                    name="challanDate"
                    id="challanDate"
                    type="date"
                    min={2023}
                    value={getShipment?.road?.challanDate}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="No. of Packages"
                    name="noOfPackages"
                    id="noOfPackages"
                    value={getShipment?.road?.noOfPackages}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Weight of Consignment"
                    name="weightOfConsignment"
                    id="weightOfConsignment"
                    value={getShipment?.road?.weightOfConsignment}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Place of Loading"
                    name="placeOfLoading"
                    id="placeOfLoading"
                    value={getShipment?.road?.placeOfLoading}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Place of Delivery"
                    name="placeOfDelivery"
                    id="placeOfDelivery"
                    value={getShipment?.road?.placeOfDelivery}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Mode of Packing"
                    name="modeOfPacking"
                    id="modeOfPacking"
                    value={getShipment?.road?.modeOfPacking}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Driver Name"
                    name="driverName"
                    id="driverName"
                    value={getShipment?.road?.driverName}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Driver Number"
                    name="driverNumber"
                    id="driverNumber"
                    value={getShipment?.road?.driverNumber}
                    onChange={handleRadioChange}
                    disabled={false}
                  />
                </Col>
                <Col xs={12} md={4} lg={3} className="commLeftRightPadding">
                  <ComboboxField
                    label="Trip Details"
                    placeholder="Select Trip Type"
                    data={tripType}
                    id="tripTypes"
                    iconClassName="dropdownIcon"
                    name="tripTypes"
                    code="tripTypesCode"
                    description="tripTypesDesc"
                    required={true}
                    getvalue={setDropdownData}
                    setValue={getShipment?.road?.tripTypes || ""}

                  />
                </Col>
                {getShipment?.road?.tripTypes === "One Way Trip" && (
                  <>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        type="date"
                        label="Trip Start Date"
                        name="tripstartDate"
                        id="tripstartDate"
                        Value={getTripType?.tripstartDate || ""}
                        onChange={TripTypeonInputChange}
                        required={true}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="From Location"
                        name="fromLocation"
                        id="fromLocation"
                        Value={getTripType?.fromLocation || ""}
                        onChange={TripTypeonInputChange}
                        required={true}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="To Location"
                        name="toLocation"
                        id="toLocation"
                        value={getTripType?.toLocation || ""}
                        onChange={TripTypeonInputChange}
                        required={true}
                      />
                    </Col>
                  </>
                )}
                {getShipment?.road?.tripTypes === "Two Way Trip" && (
                  <>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        type="date"
                        label="Trip Start Date"
                        name="tripstartDate2"
                        id="tripstartDate2"
                        value={getTripType1?.tripstartDate2 || ""}
                        onChange={TripTypeonInputChange1}
                        // disabled={true}
                        required={true}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="From Location"
                        name="fromLocation2"
                        id="fromLocation2"
                        value={getTripType1?.fromLocation2 || ""}
                        onChange={TripTypeonInputChange1}
                        // disabled={true}
                        required={true}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="To Location"
                        name="toLocation2"
                        id="toLocation2"
                        value={getTripType1?.toLocation2 || ""}
                        onChange={TripTypeonInputChange1}
                        // disabled={true}
                        required={true}
                      />
                    </Col>
                  </>
                )}
                {getShipment?.road?.tripTypes === "Round Trip" && (
                  <>
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                              <i
                                className={`bi ${isCardVisible10
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                  }`}
                                onClick={toggleCardVisibility10}
                              ></i>
                            </Col>
                            <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                              <span className="iconLogo">TD</span>
                            </Col>
                            <Col xs={12} md={3} lg={3}>
                              <span className="headerTitle">Trip Details</span>
                              <span className="subHeaderTitle">
                                Round Trip Details
                              </span>
                            </Col>
                            <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                              <Col xs={4} md={2} lg={2} className="">
                                <button className="btnTable" onClick={addPOItemRow1}>
                                  <i className="bi bi-plus-lg"></i> Add
                                </button>
                              </Col>
                            </Col>
                          </Row>
                        </h2>
                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                            }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            {" "}
                            {/* dynamicDropdown */}
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <DataTable
                                  title=""
                                  columns={SchedulePOLineItemInitialCol1}
                                  data={getPOLineItemsData1}
                                  paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                                  pagination
                                  selectableRows
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Row>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  useEffect(() => {
    const getTotal = getHeaderTextSelectedData.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue?.documentText || 0),
      0
    );
    setOtherChargesValue(getTotal);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeaderTextSelectedData]);
  /* Header text selected data */

  const [getHeaderTextSelectedData1, setHeaderTextSelectedData1] = useState([]);
  const handleHeaderTextSelectedData1 = (data) => {
    setHeaderTextSelectedData1(data);
  };
 
  const handleInputChange1 = (local_id, event, fieldName) => {
    const { value } = event.target;

    setPOLineItemsData((prevRows) =>
      prevRows.map((row) => {
        if (row.local_id === local_id) {
          const updatedRow = { ...row, [fieldName]: value };
          const quantity = parseFloat(updatedRow.purchaseQuantity) || 0;
          const unitPrice = parseFloat(updatedRow.orderPriceUnit) || 0;
          updatedRow.itemValue = (quantity * unitPrice).toFixed(2);
          return updatedRow;
        }
        return row;
      })
    );
  };
  // SAVE
  const handleSave = async () => {
    const requiredFields = [];
    // const anyFieldNotEmpty = Object.values(validation).some(
    //   (value) => value !== null && value !== ""
    // );
    // if (anyFieldNotEmpty) {
    //       requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //       setErrorFields(requiredFields);
    //       setShowFailureModal(true);
    //       return;
    //     }
    
    if (!validateRequired(formInputs.issuingDate)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        issuingDate: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    
    if (!validateRequired(formInputs?.expiryDate)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        expiryDate: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    
    const expiryDate = new Date(formInputs?.expiryDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); 
    
    if (expiryDate <= today) {
      requiredFields.push("The expiry date is not valid. The driver should not be allowed to the trip.");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        expiryDate: "Expiry date is not valid. Driver should not be allowed to the trip.",
      }));
      return;
    }
    

    formInputs[selectedShipment] = getShipment[selectedShipment];
    formInputs.othersCharge = getHeaderTextSelectedData;
    formInputs.pricingSummary.subTotalValue = subTotalValue;
    formInputs.pricingSummary.getOtherChargesValue = getOtherChargesValue;
    formInputs.pricingSummary.grossTotalValue = getGrossValue;
    formInputs.oneWayTrip = getTripType;
    formInputs.twoWayTrip = getTripType1;

    const userEnteredItemTableData = itemTableData.filter(
      (item) => item.asnQuantity != null
    );
    formInputs.items = userEnteredItemTableData;
    formInputs.items = getPOLineItemsData;
    formInputs.tripitems = getPOLineItemsData1;
    formInputs.transportrequestDetails = gettransportRequest;
    formInputs.vendorBasicValue = subTotalValue;
    formInputs.vendorOtherChargesValue = getOtherChargesValue;
    formInputs.invoiceData = invoiceData;
    formInputs.vendorTotalInvoiceValue = (
      Number(subTotalValue || 0) +
      Number(getOtherChargesValue || 0) +
      Number(formInputs.vendorTaxValue || 0) +
      Number(formInputs.vendorFreightValue || 0)
    ).toFixed(2);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: {
        ...formInputs,
        senderAddress: getCustomerDetails?.address,
        senderAddress2: getCustomerDetails?.address2,
        senderAddress3: getCustomerDetails?.address3,
        senderState: getCustomerDetails?.state,
        senderContactNumber:
          getCustomerDetails?.otherCustomerContactNumber || "",
        senderCityPostalCode: getCustomerDetails?.cityPostalCode,
        senderCertifications: getCustomerDetails?.certifications,
        senderContactName: getCustomerDetails?.otherCustomerContactName,

        senderCustomerName:
          formInputs.customerName || getCustomerDetails?.customerName,

        reciverAddress: getReciverCustomerDetails?.address,
        reciverAddress2: getReciverCustomerDetails?.address2,
        reciverAddress3: getReciverCustomerDetails?.address3,
        reciverState: getReciverCustomerDetails?.state,
        reciverContactNumber:
          getReciverCustomerDetails?.otherCustomerContactNumber || "",
        reciverCityPostalCode: getReciverCustomerDetails?.cityPostalCode,
        reciverCertifications: getReciverCustomerDetails?.certifications,
        otherReciverContactNumber: getReciverCustomerDetails?.otherReciverContactNumber,
        otherReciverContactName: getReciverCustomerDetails?.otherReciverContactName,
        reciverCustomerName:
          formInputs.reciverCustomerName ||
          getReciverCustomerDetails?.customerName,
        loactionDetails: getProjectDetails,

      },
    };
    console.log(">>obj", obj);
    setDisabled(true);
    await logistics.addLogisticsTransport(obj).then((item) => {
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_LIST);

      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const headerTextHideModal = () => {
    setViewHeaderText(false);
  };

  //price Schedule
  let POLineItemInitialData = [
    {
      local_id: 1,
      materialCode: "",
      materialDescription: "",
      materialGroup: "",
      purchaseQuantity: "",
      orderUnitOfMeasure: "",
      itemValue: "",
      orderPriceUnit: "",
      deliveryDate: "",
      plant: "",
      storageLocn: "",
    },
  ];
  let POLineItemInitialData1 = [
    {
      local_id: 1,
      tripStartedDate1: "",
      toLocation1: "",
      fromLocation1: "",
      tripKMS: "",
    },
  ];

  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData
  );

  const addPOItemRow = () => {
    setPOLineItemsData((prevRows) => {
      POLineItemInitialData[0].local_id = prevRows.length + 1;
      POLineItemInitialData[0].purchasingReqDocumentItemNr =
        prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...POLineItemInitialData];
    });
  };
  const removePOItemRow = (local_id) => {
    setPOLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };
  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;

    setPOLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
    // getTotalCount()
  };
  const [getPOLineItemsData1, setPOLineItemsData1] = useState(
    POLineItemInitialData1
  );
  const addPOItemRow1 = () => {
    setPOLineItemsData1((prevRows) => {
      POLineItemInitialData1[0].local_id = prevRows.length + 1;
      POLineItemInitialData1[0].purchasingReqDocumentItemNr =
        prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...POLineItemInitialData1];
    });
  };
  const removePOItemRow1 = (local_id) => {
    setPOLineItemsData1((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };
  const handleInputChange2 = (local_id, event, type, vat) => {
    const { name, value } = event.target;

    setPOLineItemsData1((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
    // getTotalCount()
  };
  const [, /*getTitle*/ setTitle] = useState([]);
  const [, /*getcontactPosition*/ setcontactPosition] = useState([]);
  // const [, /*getState*/ setState] = useState([]);
  const [, /*getCountry*/ setCountry] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [, /*getdocumentType*/ setdocumentType] = useState([]);
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };
  // Onselect of Country state will load

  const loadMasterData = async () => {
    let obj = {};
    await ItemServiceCustomer.getCustomers(obj).then((item) => {
      if (item?.status === 200) {
        setCustomer(item?.data);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });
  };

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.textCode === "tripTypesCode") {
      setShipment((prev) => ({
        ...prev,
        road: {
          ...prev.road,
          [getDropdownData?.textField]: getDropdownData?.name,
          // [getDropdownData?.textCode]: getDropdownData?.code,
          // [getDropdownData?.textDesc]: getDropdownData?.description,
        },
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // setValidation((prev) => ({
    //   ...prev,
    //   [getDropdownData?.textField]: "",
    // }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
    loadMasterData();
  }, [dispatch]);

  // Onselect of Country state will load
  // const getStateData = async (code) => {
  //   let obj1 = {
  //     codeType: "region",
  //     code: code,
  //   };
  //   await ItemService.getMasterDataSelf(obj1).then((item) => {
  //     // console.log('>> item!',item);
  //     if (item?.status === 200) {
  //       setState(item?.data);
  //     } else {
  //       setState([]);
  //       console.log(">> Error: Loading getMasterDataSelf");
  //     }
  //   });
  // };
  // const handleViewFileHide = () => {
  //   setShowFileViewModal(false);
  // };

  const newProject = {
    projectCode: 1,
    projectCodeDesc: "PROJECT_1",
    projectName: "",
    projectAddress: "",
    projectAddress2: "",
    projectCity: "",
    projectCountry: "IN - India",
    projectState: "IN - Karanataka",
    projectCityPostalCode: "",
    getProjectContactPerson: [
      {
        id: Date.now(), // Unique ID for the first contact person
        projectContactPosition: "",
        projectContactTitle: "",
        projectContactName: "",
        projectContactNumber: "",
        projectContactEmail: "",
      },
    ],
    getProjectCertifications: [
      {
        id: Date.now(),
        name: "Document 1",
        documentType: "",
        certificateCode: "29AADCN1012B1Z6",
        stageDocument: "",
      },
    ],
    getLocations: [],
  };
  const [, /*getRouteDetails*/ setRouteDetails] = useState([]);

  const [getProjectDetails, setProjectDetails] = useState([newProject]);
  // end 1
  useEffect(() => {
    if (formInputs.routeNumber) {
      const route1TableData = [
        {
          slNo: 1,
          routeNumber: 1,
          routeDescription: "Yalahanka",
          tollNumber: 750,
          createdAt: "2023-03-22T13:11:59.098Z",
          tollRates: 25,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
      ];
      const route2TableData = [
        {
          slNo: 1,
          routeNumber: 2,
          routeDescription: "Melkote	",
          tollNumber: 180,
          createdAt: "2023-03-22T13:11:59.098Z",
          tollRates: 6,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
        {
          slNo: 2,
          routeNumber: 2,
          routeDescription: "Doddabalapura",
          tollNumber: 180,
          createdAt: "2023-03-22T13:11:59.098Z",

          tollRates: 6,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
        {
          slNo: 3,
          routeNumber: 2,
          routeDescription: "Doddabalapura",
          tollNumber: 360,
          createdAt: "2023-03-22T13:11:59.098Z",

          tollRates: 12,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
        {
          slNo: 4,
          routeNumber: 2,
          routeDescription: "Budigere",
          tollNumber: 395,
          createdAt: "2023-03-22T13:11:59.098Z",

          tollRates: 13,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
      ];
      const route3TableData = [
        {
          slNo: 1,
          routeNumber: 3,
          routeDescription: "Free zone",
          tollNumber: 0,

          createdAt: "2023-03-22T13:11:59.098Z",
          tollRates: 0,
          noEntryTimeFromAm: "00:00AM",
          noEntryTimeToAm: "00:00AM",
          noEntryTimeFromPm: "00:00PM",
          noEntryTimeToPm: "00:00PM",
        },
      ];

      const newRouteDetails =
        formInputs.routeNumber === "1"
          ? route1TableData
          : formInputs.routeNumber === "2"
            ? route2TableData
            : formInputs.routeNumber === "3"
              ? route3TableData
              : "";

      setRouteDetails((prevRouteDetails) =>
        prevRouteDetails !== newRouteDetails
          ? newRouteDetails
          : prevRouteDetails
      );
    }
  }, [formInputs.routeNumber]);

  const onHandleMapData = (data) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Update the getLocations array with the new data
      updatedProjectDetails[data?.projectIndex] = {
        ...updatedProjectDetails[data?.projectIndex],
        getLocations: [
          ...updatedProjectDetails[data?.projectIndex].getLocations,
          {
            distance: data.distance,
            duration: data.duration,
            fromToCoords: data.fromToCoords,
            plantAddress: data.plantAddress,
            projectLocation: data.projectLocation,
          },
        ],
      };

      return updatedProjectDetails;
    });
  };

  const othersOnInputChange = ({ target: { name, value } }) => {
    setCustomerDetails((customerDetails) => ({
      ...customerDetails,
      [name]: value,
    }));
  };

  const othersRecevierOnInputChange = (e) => {
    const { name, value } = e.target;
    setReciverCustomerDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const total = getPOLineItemsData.reduce((acc, curr) => {
      const value = parseFloat(curr.itemValue) || 0;
      return acc + value;
    }, 0);
    setSubTotalValue(total.toFixed(2)); // Save it as string with 2 decimals
  }, [getPOLineItemsData]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Create Transport Request
              <span>
                {getHeaderData?.statusHeader === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "In Release" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : (
                  getHeaderData?.statusHeader
                )}
              </span>
            </h2>
            <p className="subText">Fill Transport Request Details</p>
            <hr />

            {/*Document Header Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible8
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        {" "}
                        Transport Request Details
                      </span>
                      <span className="subHeaderTitle">
                        Transport Request Details
                      </span>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transport request Date"
                          type="date"
                          min={2023}
                          name="transportRequestDate"
                          placeholder=""
                          // value={formInputs?.shippingTo?.shippingToCompany}
                          onChange={transportRequestInputchange}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="department"
                          placeholder=""
                          onChange={transportRequestInputchange}
                          required={true}
                        />
                      </Col>

                      {/* {getHeaderData?.purchasingDocumentValue && ( */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transport Group"
                          name="transportGroup"
                          placeholder=""
                          onChange={transportRequestInputchange}
                          required={true}
                        />
                      </Col>
                      {/* )} */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchase order Nr/sales Order Nr"
                          name="purchaseOrderNr"
                          placeholder=""
                          onChange={transportRequestInputchange}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vehicle Nr"
                          name="vehicleNr"
                          placeholder=""
                          onChange={transportRequestInputchange}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Driver Name"
                          name="driverName1"
                          placeholder=""
                          onChange={transportRequestInputchange}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="License Nr"
                          name="licenseNr"
                          placeholder=""
                          onChange={transportRequestInputchange}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Issuing Date"
                          name="issuingDate"
                          type="date"
                          min={2018}
                          placeholder=""
                          onChange={transportRequestInputchange}
                          required={true}
                          error={validation.issuingDate}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Expiry Date"
                          name="expiryDate"
                          type="date"
                          min={2018}
                          placeholder=""
                          onChange={transportRequestInputchange}
                          required={true}
                          error={validation.expiryDate}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CS</span>
                    </Col>
                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle"> Consignor/Sender</span>
                      <span className="subHeaderTitle">Consignor/Sender</span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={handleOnAddSender}
                        >
                          <i className="bi bi-plus-lg"></i> <span className="d-lg-inline d-none">Add</span>
                        </button>
                      </Col>
                    </Col>

                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {senderOthersCustomer && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Name"
                              id="customerName"
                              name="customerName"
                              placeholder=""
                              value={getCustomerDetails?.customerName}
                              onChange={othersOnInputChange}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Address"
                              id="address"
                              name="address"
                              value={getCustomerDetails?.address}
                              onChange={othersOnInputChange}
                      
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Pin Code"
                              id="cityPostalCode"
                              name="cityPostalCode"
                              // type="text"
                              value={getCustomerDetails?.cityPostalCode}
                              onChange={othersOnInputChange}
                            
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Name"
                              id="otherCustomerContactName"
                              name="otherCustomerContactName"
                              // type="text"
                              value={
                                getCustomerDetails?.otherCustomerContactName
                              }
                              onChange={othersOnInputChange}
                      
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Number"
                              id="otherCustomerContactNumber"
                              name="otherCustomerContactNumber"
                              // type="text"
                              value={
                                getCustomerDetails?.otherCustomerContactNumber
                              }
                              onChange={othersOnInputChange}
                          
                            />
                          </Col>

                        </Row>
                      )}
                      {!senderOthersCustomer && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Customer Name 1"
                              placeholder=""
                              data={getCustomer}
                              id="customerName"
                              iconClassName="dropdownIcon"
                              name="customerName"
                              code="customerCode"
                              description="customerNameDesc"
                              setValue={formInputs?.customerName || ""}
                              getvalue={setDropdownData}
                              required={true}
                            // error={validation.country}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Customer Address"
                              name="projectAddress"
                              value={[
                                getCustomerDetails?.address,
                                getCustomerDetails?.address2,
                                getCustomerDetails?.address3,
                                getCustomerDetails?.state,
                                getCustomerDetails?.cityPostalCode,
                              ]
                                .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
                                .join(" ")}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible1
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CR</span>
                    </Col>
                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle"> Consignee/Receiver</span>
                      <span className="subHeaderTitle">To Address</span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={hanleOnAddReceiver}
                        >
                          <i className="bi bi-plus-lg"></i> <span className="d-lg-inline d-none">Add</span>
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {reciverOthersCustomer && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Name"
                              id="customerName"
                              name="customerName"
                              placeholder=""
                              value={getReciverCustomerDetails?.customerName || ""}

                              onChange={othersRecevierOnInputChange}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Address"
                              id="address"
                              name="address"
                              value={getReciverCustomerDetails?.address || ""}
                              onChange={othersRecevierOnInputChange}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Pin Code"
                              id="cityPostalCode"
                              name="cityPostalCode"
                              // type="text"
                              value={
                                getReciverCustomerDetails?.cityPostalCode || ""
                              }
                              onChange={othersRecevierOnInputChange}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Name"
                              id="otherReciverContactName"
                              name="otherReciverContactName"
                              // type="text"
                              value={
                                getReciverCustomerDetails?.otherReciverContactName || ""
                              }
                              onChange={othersRecevierOnInputChange}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Number"
                              id="otherReciverContactNumber"
                              name="otherReciverContactNumber"
                              // type="text"
                              value={
                                getReciverCustomerDetails?.otherReciverContactNumber || ""
                              }
                              onChange={othersRecevierOnInputChange}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                        </Row>
                      )}
                      {!reciverOthersCustomer && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Customer Name 2"
                              placeholder=""
                              data={getCustomer}
                              id="reciverCustomerName"
                              iconClassName="dropdownIcon"
                              name="reciverCustomerName"
                              code="reciverCustomerCode"
                              description="reciverCustomerNameDesc"
                              setValue={formInputs?.reciverCustomerName || ""}
                              getvalue={setDropdownData}
                              required={true}
                            // error={validation.country}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Customer Address"
                              name="projectAddress"
                              value={[
                                getReciverCustomerDetails?.address,
                                getReciverCustomerDetails?.address2,
                                getReciverCustomerDetails?.address3,
                                getReciverCustomerDetails?.state,
                                getReciverCustomerDetails?.cityPostalCode,
                              ]
                                .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
                                .join(" ")}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Price Shedule / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible4
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>
                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle">Item Details</span>
                      <span className="subHeaderTitle">
                        Price Shedule / Line Item
                      </span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button className="btnTable" onClick={addPOItemRow}>
                          <i className="bi bi-plus-lg"></i> <span className="d-lg-inline d-none">Add</span>
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={SchedulePOLineItemInitialCol}
                          data={getPOLineItemsData}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* radio buttons */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible5
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MT</span>
                    </Col>

                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle">Mode of Transport</span>
                      <span className="subHeaderTitle">Transport Details</span>
                    </Col>
                    <Col xs={4} md={1} lg={4}></Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="d-flex fs-5 fw-medium ms-3 my-3">
                          <div className="d-flex align-items-center me-3">
                            <div className="form-check">
                              <input
                                ref={inputRef}
                                className="form-check-input me-2"
                                type="radio"
                                value="road"
                                checked={selectedShipment === "road"}
                                onChange={handleShipmentChange}
                              />
                              <label
                                className="form-check-label fs-5"
                                htmlFor="shipment1"
                              >
                                Road
                              </label>
                            </div>
                          </div>
                        </div>
                        <div>{renderShipmentDetails()}</div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Project Details*/}

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LN</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Location Details </span>
                      <span className="subHeaderTitle">Location Details</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3"></div>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    {getProjectDetails &&
                      getProjectDetails?.map((item, index) => (
                        <div key={index}>
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                                Location Details
                              </h5>
                              <span className="deleteIconAccordion"></span>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <div>
                                <div className="d-flex-column justify-content-center">
                                  <Row>
                                    <Col xs={12} md={5} lg={5}>
                                      <h5 className="bg-table-status bg-table-warning-status mt-4">
                                        Locations
                                      </h5>
                                    </Col>
                                    <Col xs={12}>
                                      <div className="accordion-body">
                                        <div className="d-flex-column justify-content-center">
                                          {/* <GoogleMapComponent
                                            projectIndex={index}
                                            getmapdata={onHandleMapData}
                                            passmapdata={false}
                                            editstatus={false}
                                          /> */}
                                          <GoogleMapComponentFromTo
                                            projectIndex={index}
                                            getmapdata={onHandleMapData}
                                            passmapdata={false}
                                            editstatus={false}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <hr />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {/* other changes table */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible7
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OC</span>
                    </Col>

                    <Col xs={5} md={9} lg={9}>
                      <span className="headerTitle">Other Charges</span>
                      <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <button className="btnTable" onClick={showsetHeaderText}>
                        <i className="bi bi-plus-lg"></i>
                      </button>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={HeaderTextColumns}
                          data={getHeaderTextSelectedData}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing Summary */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible6
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PS</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Pricing Summary</span>
                      <span className="subHeaderTitle">Pricing Summary </span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body p-2">
                    <Row className=" ms-3 ">
                      <Col
                        xs={8}
                        md={4}
                        lg={4}
                        className="d-flex my-2 jsutify-content-center align-items-center"
                      >
                        <p className="fw-medium">
                          SubTotal Pricing Schedule / Line Items
                        </p>
                      </Col>
                      <Col
                        xs={4}
                        md={6}
                        lg={6}
                        className="d-flex my-2 jsutify-content-center align-items-center"
                      >
                        <InputField
                          className="inputBox"
                          name="subTotalValue"
                          placeholder=""
                          value={subTotalValue}
                          disabled={true}
                          onChange={pricingSummaryInputchange}
                        />
                        {/* <p className="ms-4 fw-medium"> AED</p> */}
                      </Col>
                      <Col
                        xs={8}
                        md={4}
                        lg={4}
                        className="d-flex my-2 jsutify-content-center align-items-center "
                      >
                        <p className="fw-medium"> SubTotal Other Charges</p>
                      </Col>
                      <Col
                        xs={4}
                        md={7}
                        lg={7}
                        className="d-flex my-2 jsutify-content-center align-items-center "
                      >
                        <InputField
                          className="inputBox"
                          name="getOtherChargesValue"
                          placeholder=""
                          value={getOtherChargesValue}
                          onChange={otherChargeInputchange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={8}
                        md={4}
                        lg={4}
                        className="d-flex my-2 jsutify-content-center align-items-center"
                      >
                        <p className="fw-medium">Gross Total</p>
                      </Col>
                      <Col
                        xs={4}
                        md={7}
                        lg={7}
                        className="d-flex jsutify-content-center align-items-center"
                      >
                        <InputField
                          className="inputBox"
                          name="grossTotalValue"
                          placeholder=""
                          value={getGrossValue}
                          disabled={true}
                          onChange={GrossValueInputchange}

                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* invoice details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible2
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Invoice details</span>
                      <span className="subHeaderTitle">Invoice details</span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Number *"
                                name="vendorInvoiceNo"
                                id="vendorInvoiceNo"
                                value={formInputs.vendorInvoiceNo}
                                onChange={onInputChange}
                                disabled={false}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Date*"
                                name="vendorInvoiceDate"
                                id="vendorInvoiceDate"
                                type="date"
                                value={formInputs.vendorInvoiceDate}
                                onChange={onInputChange}
                                disabled={false}
                              />
                            </Col>

                            <Col xs={12} md={4} lg={3} className="commTopButtonRightLeftPadding">
                              <InputField
                                className="inputBox"
                                label="Basic Value *"
                                name="vendorBasicValue"
                                placeholder="0.00"
                                id="vendorBasicValue"
                                hedertextdata={handleHeaderTextSelectedData1}
                                showcurrentdata={getHeaderTextSelectedData1}
                                value={subTotalValue}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Tax Amount"
                                name="vendorTaxValue"
                                placeholder="0.00"
                                id="vendorTaxValue"
                                value={formInputs.vendorTaxValue}
                                onChange={onInputChange}
                                disabled={false}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Other Charges"
                                name="vendorOtherChargesValue"
                                placeholder="0.00"
                                id="vendorOtherChargesValue"
                                value={getOtherChargesValue.toFixed(2)}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Invoice Value "
                                name="vendorTotalInvoiceValue "
                                placeholder="0.00"
                                id="vendorTotalInvoiceValue"
                                value={(
                                  Number(subTotalValue || 0) +
                                  Number(getOtherChargesValue || 0) +
                                  Number(formInputs.vendorTaxValue || 0) +
                                  Number(formInputs.vendorFreightValue || 0)
                                ).toFixed(2)}
                                // onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                          </Row>
                          <hr className="mx-4 mb-3" />
                          <Row className="commLeftRightPadding">
                            <Col md={{ span: 3, offset: 9 }}>
                              <button
                                className="btn w-full"
                                onClick={addInvoiceDocument}
                              >
                                Add Document
                              </button>
                            </Col>
                          </Row>

                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={6} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-25">
                                  File
                                </p>
                              </Col>
                              <Col xs={5} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-20">
                                  View Files
                                </p>
                              </Col>
                              <Col xs={1} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-25">
                                  Action
                                </p>
                              </Col>
                            </Row>
                            {invoiceData.map((doc, index) => (
                              <Row key={index}>
                                <Col xs={12} md={12} lg={12}>
                                  <hr className="mx-4 my-0 text-color-black" />
                                </Col>
                                <Col
                                  xs={5}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <FileUploadComponent
                                    id={doc.id}
                                    name="purchaseOrderFileAttachment"
                                    label="Customer PO"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true} // Change to false for single file selection
                                    required={true}
                                    onSuccessUpload={
                                      onSuccessUploadDocumentType
                                    }
                                    value={
                                      doc.purchaseOrderFileAttachment || ""
                                    }
                                  />
                                </Col>
                                <Col
                                  xs={5}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {(doc.purchaseOrderFileAttachment && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          doc.purchaseOrderFileAttachment
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </Col>

                                <Col
                                  xs={2}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <i
                                    onClick={() =>
                                      deleteInvoiceDocument(doc.id)
                                    }
                                    className="bi bi-trash text-danger fs-4"
                                  />
                                </Col>
                              </Row>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div className="pageFooter">
        <Row className="rowDirection">
          <Col xs={12} md={2} lg={2} className="commTopButtonRightLeftPadding">
            <button
              className="btn w-full"
              onClick={handleSave}
              disabled={disabled}
            >
              <i className="bi bi-save"></i> Create
            </button>
          </Col>
        </Row>
      </div>

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE}
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Header Text  */}
      <CommonItemLevelDatatableModal
        show={getViewHeaderText}
        onHide={() => headerTextHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <FailureModal
              show={getShowFailureModal}
              onHide={() => hideFailureModal()}
              failuremodaldata={getFailureModal}
              requiredfields={getErrorFields}
            />
    </main>
  );
};

export default CreateTransportRequest;
